/* eslint-disable global-require */
// import './assets/css/vendor/bootstrap.min.css';
// import './assets/css/vendor/bootstrap.rtl.only.min.css';
import 'react-perfect-scrollbar/dist/css/styles.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-image-lightbox/style.css';

const render = () => {
  import(`./assets/css/sass/themes/light.bluenavy.scss`).then(() => {
    require('./AppRenderer');
  });
};
render();
